import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../serialization/DataClassPathSerializer.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.UpdateRestrictionsPart', null, 3);
        tmp0_serialDesc.c1b('path', false);
        tmp0_serialDesc.c1b('limitedIf', false);
        tmp0_serialDesc.c1b('limitedTo', false);
        this.z2l_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer().g4b(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static h4b() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.UpdateRestrictionsPart', $this, 3);
        tmp0_serialDesc.c1b('path', false);
        tmp0_serialDesc.c1b('limitedIf', false);
        tmp0_serialDesc.c1b('limitedTo', false);
        $this.e4b_1 = tmp0_serialDesc;
        return $this;
      }
      i4b(encoder, value) {
        var tmp0_desc = this.e4b_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, new (DataClassPathSerializer())(this.f4b_1), value.e2m_1);
        tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.f4b_1), value.f2m_1);
        tmp1_output.c15(tmp0_desc, 2, new (ConditionSerializer())(this.f4b_1), value.g2m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i4b(encoder, value instanceof UpdateRestrictionsPart() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e4b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, new (DataClassPathSerializer())(this.f4b_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.f4b_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (ConditionSerializer())(this.f4b_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, new (DataClassPathSerializer())(this.f4b_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.f4b_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (ConditionSerializer())(this.f4b_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return UpdateRestrictionsPart().j4b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.e4b_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (DataClassPathSerializer())(this.f4b_1), new (ConditionSerializer())(this.f4b_1), new (ConditionSerializer())(this.f4b_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.f4b_1];
      }
      static g4b(typeSerial0) {
        var $this = this.h4b();
        $this.f4b_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var UpdateRestrictionsPartClass;
function UpdateRestrictionsPart() {
  if (UpdateRestrictionsPartClass === VOID) {
    class $ {
      constructor(path, limitedIf, limitedTo) {
        Companion_getInstance();
        this.e2m_1 = path;
        this.f2m_1 = limitedIf;
        this.g2m_1 = limitedTo;
      }
      k4b(path, limitedIf, limitedTo) {
        return new (UpdateRestrictionsPart())(path, limitedIf, limitedTo);
      }
      i2m(path, limitedIf, limitedTo, $super) {
        path = path === VOID ? this.e2m_1 : path;
        limitedIf = limitedIf === VOID ? this.f2m_1 : limitedIf;
        limitedTo = limitedTo === VOID ? this.g2m_1 : limitedTo;
        return $super === VOID ? this.k4b(path, limitedIf, limitedTo) : $super.k4b.call(this, path, limitedIf, limitedTo);
      }
      toString() {
        return 'UpdateRestrictionsPart(path=' + this.e2m_1.toString() + ', limitedIf=' + toString(this.f2m_1) + ', limitedTo=' + toString(this.g2m_1) + ')';
      }
      hashCode() {
        var result = this.e2m_1.hashCode();
        result = imul(result, 31) + this.f2m_1.hashCode() | 0;
        result = imul(result, 31) + this.g2m_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UpdateRestrictionsPart()))
          return false;
        if (!this.e2m_1.equals(other.e2m_1))
          return false;
        if (!this.f2m_1.equals(other.f2m_1))
          return false;
        if (!this.g2m_1.equals(other.g2m_1))
          return false;
        return true;
      }
      static j4b(seen0, path, limitedIf, limitedTo, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, Companion_getInstance().z2l_1);
        }
        var $this = createThis(this);
        $this.e2m_1 = path;
        $this.f2m_1 = limitedIf;
        $this.g2m_1 = limitedTo;
        return $this;
      }
    }
    initMetadataForClass($, 'UpdateRestrictionsPart', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    UpdateRestrictionsPartClass = $;
  }
  return UpdateRestrictionsPartClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.UpdateRestrictions', null, 1);
        tmp0_serialDesc.c1b('fields', true);
        this.p2l_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer_0().m41(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static l4b() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.UpdateRestrictions', $this, 1);
        tmp0_serialDesc.c1b('fields', true);
        $this.k41_1 = tmp0_serialDesc;
        return $this;
      }
      m4b(encoder, value) {
        var tmp0_desc = this.k41_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.w2l_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, new (ArrayListSerializer())($serializer().g4b(this.l41_1)), value.w2l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m4b(encoder, value instanceof UpdateRestrictions() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k41_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())($serializer().g4b(this.l41_1)), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())($serializer().g4b(this.l41_1)), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return UpdateRestrictions().n4b(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.k41_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ArrayListSerializer())($serializer().g4b(this.l41_1))];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.l41_1];
      }
      static m41(typeSerial0) {
        var $this = this.l4b();
        $this.l41_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var UpdateRestrictionsClass;
function UpdateRestrictions() {
  if (UpdateRestrictionsClass === VOID) {
    class $ {
      constructor(fields) {
        Companion_getInstance_0();
        var tmp;
        if (fields === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = fields;
        }
        fields = tmp;
        this.w2l_1 = fields;
      }
      y2l(fields) {
        return new (UpdateRestrictions())(fields);
      }
      toString() {
        return 'UpdateRestrictions(fields=' + toString(this.w2l_1) + ')';
      }
      hashCode() {
        return hashCode(this.w2l_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UpdateRestrictions()))
          return false;
        if (!equals(this.w2l_1, other.w2l_1))
          return false;
        return true;
      }
      static n4b(seen0, fields, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance_0().p2l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.w2l_1 = emptyList();
        } else
          $this.w2l_1 = fields;
        return $this;
      }
    }
    initMetadataForClass($, 'UpdateRestrictions', UpdateRestrictions, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    UpdateRestrictionsClass = $;
  }
  return UpdateRestrictionsClass;
}
//region block: exports
export {
  $serializer_0 as $serializerxnzp9a2xfffv,
  UpdateRestrictionsPart as UpdateRestrictionsPartrteren0lopt2,
  UpdateRestrictions as UpdateRestrictions6ebv9x6ps9p5,
  Companion_getInstance_0 as Companion_getInstance1gfb55agtbi7k,
  Companion_getInstance as Companion_getInstance9xluupucl4vq,
};
//endregion

//# sourceMappingURL=UpdateRestrictions.mjs.map
